// extracted by mini-css-extract-plugin
module.exports = {"hiddenInput":"hidden_hiddenInput__4aBLk"};